import { Instagram, Twitter, Youtube } from "lucide-react";

const COLUMNS = [
  {
    title: "Maison",
    links: ["The House", "Founder", "Atelier", "Sustainability"],
  },
  {
    title: "Edits",
    links: ["DenimGlow", "Lookbook", "Journal", "Archive"],
  },
  {
    title: "Care",
    links: ["Concierge", "Repair", "Shipping", "Returns"],
  },
];

export default function FooterSection() {
  return (
    <footer
      id="footer"
      data-testid="footer"
      className="relative bg-midnight-deep border-t border-white/8 pt-24 md:pt-32 pb-10 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        {/* Brand */}
        <div className="md:col-span-5">
          <div className="font-serif text-white text-3xl tracking-[0.18em]">
            ASYMMETRY
          </div>
          <div className="text-[10px] tracking-[0.45em] uppercase text-silver mt-2">
            Edits · Maison of DenimGlow
          </div>
          <p className="mt-8 max-w-md text-white/55 font-light leading-relaxed">
            A contemporary fashion house reimagining apparel, jewellery,
            leather and accessories through artistic design and modern
            craftsmanship.
          </p>
          <div className="mt-8 space-y-2 text-sm text-white/70 font-light">
            <div>
              <span className="text-silver/70 text-[10px] tracking-[0.35em] uppercase mr-3">
                Atelier
              </span>
              Milano
            </div>
            <div>
              <span className="text-silver/70 text-[10px] tracking-[0.35em] uppercase mr-3">
                Concierge
              </span>
              contact@asymmetryedits.com
            </div>
          </div>

          <div className="mt-10 flex items-center gap-5">
            {[
              { icon: Instagram, label: "instagram" },
              { icon: Twitter, label: "twitter" },
              { icon: Youtube, label: "youtube" },
            ].map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                data-testid={`footer-social-${label}`}
                className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-white transition-all duration-500"
              >
                <Icon size={15} strokeWidth={1.2} />
              </a>
            ))}
          </div>
        </div>

        {/* Columns */}
        {COLUMNS.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <div className="text-[10px] tracking-[0.4em] uppercase text-silver/70 mb-6">
              {c.title}
            </div>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    className="text-white/70 hover:text-white font-light text-sm tracking-wide transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Newsletter mini */}
        <div className="md:col-span-1" />
      </div>

      {/* Mega brand */}
      <div className="relative mt-20 md:mt-28 pointer-events-none select-none">
        <div className="mega-text text-white/[0.045] text-[18vw] leading-none text-center">
          ASYMMETRY
        </div>
      </div>

      {/* Bottom row */}
      <div className="mt-12 border-t border-white/8 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] tracking-[0.32em] uppercase text-white/40">
        <div>© MMXXVI · Asymmetry Edits — All Rights Reserved</div>
        <div className="flex gap-8">
          <a href="#" className="hover:text-white transition-colors">
            Privacy
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Terms
          </a>
          <a href="#" className="hover:text-white transition-colors">
            Cookies
          </a>
        </div>
      </div>
    </footer>
  );
}
